import Vue from 'vue';
//分转元
Vue.filter('centConvertYuan', function (value) {
    return (value / 100).toFixed(2);
});
